module.exports = __webpack_public_path__ + "static/media/team-rocket-miss.9e005aeb.wav";